import React from "react";
import { connect } from "react-redux";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import GeneralLoader from "../../GeneralLoader";
import LocationMap from "../maps/LocationMap";

class AddressMapDialog extends React.PureComponent {
	render() {
		const { translations, address } = this.props;

		let buttons = [
			{
				type: Button,
				text: translations.sections.buttons.close,
				action: () => {
					this.props.handleClose();
				}
			}
		];

		return this.props.show ? (
			<Modal title={translations.sections.review_record.map_dialog_title} buttons={buttons}>
				<h3>{this.props.address}</h3>
				<LocationMap
					address={address}
					loadingElement={<GeneralLoader />}
					googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyA2mfXsrW3E8ZKx7pxKPFBRy-qE-wAEgOg&libraries=places"
					height={"300px"}
				/>
			</Modal>
		) : null;
	}
}

const mapStateToProps = (state, props) => {
	return {
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(AddressMapDialog);



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/AddressMapDialog.js